import {
  NotFoundContainer,
  NotFoundHDescription,
  NotFoundHeader
} from '../../../styled-components.js'
import NotFoundComponent from '../../../../../molecules/not-found/index.jsx'
import { NotFound } from '../../../../../atoms/icons/core/index.js'
import { FormattedMessage } from 'react-intl'

const GlobalSearchNotFound = () => {
  return (
    <NotFoundContainer>
      <NotFoundComponent
        icon={<NotFound style={{ width: '60px', height: '60px' }} />}
        header={
          <NotFoundHeader>
            <FormattedMessage id="pinList_noResult" />
          </NotFoundHeader>
        }
        description={
          <NotFoundHDescription>
            <FormattedMessage id="no_search_found" />
          </NotFoundHDescription>
        }
        style={{
          maxWidth: '240px'
        }}
      />
    </NotFoundContainer>
  )
}

export default GlobalSearchNotFound
